<template>
  <Modal width="1000" class="align-l" v-model="show" :mask-closable="false" v-if="deliverysInfo">
    <div slot="header" class="modal-header">{{projectName}}<span class="dot" style="padding-ledt:0;">.</span>{{houseNumber}}</div>
 
    <div class="item pt16 pb16">
      <h4 class="mb8">生活费用信息</h4>
      <table-list :showPage ="false" :columns="meterColumns" :data="deliverysInfo.meterList" :loading="costLoading"></table-list>
    </div>

    <div class="item pt16 pb16">
      <h4 class="mb8">房间物品信息</h4>
      <table-list :showPage ="false" :columns="goodsColumns" :data="deliverysInfo.goodsList" :loading="goodsLoading"></table-list>
    </div>

    <div slot="footer">   
      <Button type="primary" size="large" @click="close">确定</Button>
    </div>

  </Modal>
</template>
 
<script type="text/ecmascript-6">
import TableList from "components/TableList/index";
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    deliverysInfo:{
      type:Object,
      default:null
    },
    projectName:{
      type: String,
      default:'项目名称'
    },
    houseNumber:{
      type:String,
      default:''
    }
  },
  watch:{
    n(val){
      // 重新获取交割数据
      this.show = true
    }
  },
  components:{
    TableList
  },
 data () {
  return {
    show:false,
    costLoading:false,
    goodsLoading:false,
    decorationLoading:false,
     meterColumns:[
      {
        title: "项目类型",
        key: "meterTypeName",
        align: "center"
      },
      {
        title:'是否智能',
        key:'isSmartDevice',
        align:'center',
        render:(h,params) => {
          return h('span',params.row.isSmartDevice? '是':'否')
        }
      },
      {
        title: "付费模式",
        key: "meterPayType",
        align: "center",
        render:(h,params) => {
          return h('span',params.row.meterPayType === 0? '预付费':'后付费')
        }
      
      },
      {
        title: "底数",
        key: "curMeterDisplay",
        align: "center"  
      },
      {
        title: "附件",
        key: "meterPic",
        align: "center",
        render: (h,params) => {
          return h('span',{
            style:{
              color: '#CFA868',
              cursor: params.row.meterPic ? 'pointer': 'auto'
            },
            on: {
              click: ()=>{
                if(params.row.meterPic){
                  this.$emit('showimg', params.row.meterPic)
                }
              }
            }
          },params.row.meterPic ?'查看': '-')
        }
      },
      {
        title: "备注",
        key: "remark",
        align: "center",
        render: (h,params) => {
          return h('span',params.row.remark || '-')
        }
      }
    ],       
    goodsColumns:[
      {
        title: "类目",
        key: "goodsType",
        align: "center"
      },
      {
        title: "物品",
        key: "goodsName",
        align: "center"
      },
      {
        title: "数量",
        key: "goodsCount",
        align: "center"
      },
      {
        title: "价格",
        key: "goodsPrice",
        align: "center"
      },
      {
        title: "状态",
        key: "goodsStatusName",
        align: "center",
        // render:(h,params) => {
        //   let str = ''
        //   switch(params.row.goodsStatus){
        //     case 0: 
        //       str = '正常'
        //       break;
        //     case 1: 
        //       str = '损坏'
        //       break;
        //     case 2: 
        //       str = '报废'
        //       break;
        //     case 3: 
        //       str = '终结'
        //       break;
        //     default:
        //     str = ''
        //   }
        //   return h('span',str)
        // }
      },
      {
        title: "赔付费用",
        key: "goodsPayAmount",
        align: "center"
      }
    ]
 };
 },
 methods:{
close() {
  this.show = false
}
 }
}
</script>
